//We use the same empty object to ref count the styles that don't need a theme object.
const noopTheme = {};
export default noopTheme;;